<cmv-modal-base [isModalOpen]="isModalOpen">
	<section class="full-size-loading">
		<span class="full-size-loading__spinner"></span>
		<p class="full-size-loading__message">{{ loadingMessage }}</p>
	</section>
</cmv-modal-base>
